<template>
    <v-sheet
        class="mx-auto text-center"
        max-width="700"
        v-show="canShowRoomItems"
    >
        <v-slide-group
            multiple
            :show-arrows="!$vuetify.breakpoint.xs"
        >
            <v-slide-item
                v-for="(roomItem, index) of roomItems"
                :key="index"
            >
                <v-menu
                    v-show="roomItem.visible == true"
                    background-color="grey"
                    bottom
                    offset-y
                    max-width="213"
                    content-class="room-item-menu"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-chip
                            class="room-item ma-2"
                            :class="{'active': attrs['aria-expanded']=== 'true'}"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            @click="changeActive(index)"
                        >  
                            {{ roomItem.name }}
                            <v-btn  icon >
                                <v-icon right class="mdi">
                                    mdi-chevron-down
                                </v-icon>
                            </v-btn>
                        </v-chip>
                    </template>
                    <v-list-item class=" room-title text-uppercase justify-center">
                        {{ roomItem.name }}
                    </v-list-item>
                    <v-list-item-group
                        v-model="modelConfig"
                        active-class="active"
                    >
                        <RoomItem
                            v-for="(material, materialIndex) in roomItem.materials"
                            :key="`material-${materialIndex}`"
                            :material="material"
                            :materialIndex="materialIndex"
                            :roomItem="roomItem"
                            :roomItems="roomItems"
                            :harmonyMaterials="roomItem.type === 'harmony' ? getMaterialsFromCombination(material.combinations) : null"
                        />
                    </v-list-item-group>
                </v-menu>
            </v-slide-item>
        </v-slide-group>
    </v-sheet>
</template>

<script>
    import { EventBus } from "@/event-bus";
    import RoomItem from '@/components/configurableTour/components/RoomItem.vue';
    import MaterialPreview from '@/components/configurableTour/components/MaterialPreview';

    export default {
        name: 'RoomItemsFooter',
        components: {
            RoomItem,
            MaterialPreview
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        computed :{
            roomItems(){
                if (this.activatedRoom !== null)
                    return this.data.configurationOptions[this.activatedRoom].items.filter(item => item.visible) || {};
            },
            canShowRoomItems(){
                if (this.activatedRoom !== null)
                    return this.roomItems && this.data.configurationOptions[this.activatedRoom].hasCombination;
            }
        },
        data: () => ({
            modelConfig: null,
            activatedRoom: null,
        }),
        mounted() {
            if (this.data.configurationOptions) {
                this.activatedRoom = this.$props.data.configurationOptions.findIndex(options => options.hasCombination === true)
                this.$props.data.configurationOptions[this.activatedRoom].active = true;
            }
        },
        methods: {
            getMaterialsFromCombination(combinations) {
                let materialList = [];
                Object.keys(combinations).forEach(roomId => {
                    materialList.push({
                        'id': combinations[roomId],
                        'text': this.$props.data.materials[combinations[roomId]]
                    });
                });
                return materialList;
            }, 
            changeActive(index){
                this.modelConfig = this.roomItems[index] ? this.roomItems[index].materials.indexOf(this.roomItems[index].materials.filter(x => x.active)[0]) : null;
            }
        },
        watch: {
            'data.configurationOptions': {
                handler: function (newConfig, oldConfig) {
                    if (newConfig) {
                        this.activatedRoom = this.data.configurationOptions.findIndex(configuration => configuration.active);
                        EventBus.$emit('loadRoom', this.activatedRoom);
                    }
                },
                deep: true
            },
        },
    }
</script>

<style lang="scss">
    .material {
        &-list {
            background-color: green;
            .v-list-group {
                .v-list-group__header {
                    .v-list-item__title {
                        color: #000000;
                    }
                    .v-list-item__icon {
                        i {
                            font-size: 24px !important;
                        }
                    }
                }
            }

            .v-subheader {
                padding: unset;
            }
            .v-list-item__title {
                overflow: unset;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/layout/alternative/configurableTour/components/RoomsItemsFooter.vue